import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/nxr/NXR_Slider_1.jpg';
import projectImage2 from '../../../../assets/images/work/nxr/NXR_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/nxr/NXR_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/nxr/NXR_Slider_4.jpg';

import Data_NXR from './Data_NXR';

function Work_NXR() {
    return (
        <>
            <DetailedHeader
                heading="A Platform for Continuous Content Delivery"
                client="NORCAT"
                service="Platform"
                date="2019-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_NXR.content}
        </>
    );
}

export default Work_NXR;
